var map = {
	"./obj_mascot_1_1.png": 78558,
	"./obj_mascot_1_10.png": 71388,
	"./obj_mascot_1_2.png": 45909,
	"./obj_mascot_1_3.png": 76812,
	"./obj_mascot_1_4.png": 6979,
	"./obj_mascot_1_5.png": 89402,
	"./obj_mascot_1_6.png": 19569,
	"./obj_mascot_1_7.png": 21704,
	"./obj_mascot_1_8.png": 3967,
	"./obj_mascot_1_9.png": 7638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74648;